module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Детали транзакции\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'transactions'
      }
    }
  }, [_vm._v("← Назад к Транзакциям")])], 1), _vm._v(" "), _c('transactionDetail', {
    attrs: {
      "transaction-id": _vm.$route.params.transaction_id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3c280b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/transaction/TransactionDetails.vue
// module id = 700
// module chunks = 0